export default __webpack_public_path__ + "static/media/ICI.03859d05.png";